import { Drawer, DrawerBody, DrawerHeader, DrawerHeading, DrawerProps, IconLinkButton, Id, Loading } from "@dgs/core";
import { useQuery } from "@tanstack/react-query";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import styled from "styled-components";
import { contactUpdateInquiryService } from "../shared/api/contactUpdateInquiryService";

const ContactList = styled.ul`
	padding-top: ${({ theme }) => theme.spacing(8)};
	padding-left: ${({ theme }) => theme.spacing(4)};
`;

const ContactRow = styled(Link)`
	display: flex;
	justify-content: space-between;
	align-items: center;
	color: inherit;
`;

export const ContactUpdateInquiryConflictDrawer: FC<DrawerProps & { conflictUpdateInquiryId: Id }> = ({
	conflictUpdateInquiryId,
	...drawerProps
}) => {
	const { t } = useTranslation();
	const { data } = useQuery({
		queryKey: contactUpdateInquiryService.contactsWithConflictsKey(conflictUpdateInquiryId),
		queryFn: () => contactUpdateInquiryService.contactsWithConflicts(conflictUpdateInquiryId).then((r) => r.data.data),
	});

	return (
		<Drawer {...drawerProps}>
			<DrawerHeader onClose={drawerProps.onClose}>
				<DrawerHeading>{t("Conflicts")}</DrawerHeading>
			</DrawerHeader>
			<DrawerBody>
				{data !== undefined ? (
					<>
						<span>
							{t(
								"The following contacts can not be added to this contact update campaign because they already are part of another contact update campaign:",
							)}
						</span>
						<ContactList>
							{data.map((contact) => (
								<li key={contact.id}>
									<ContactRow to={`/contacts/active/${contact.id}/details`}>
										<span>
											{contact.firstName} {contact.lastName} ({contact.email})
										</span>
										<IconLinkButton
											to={`/contacts/active/${contact.id}/details`}
											title={t("Show contact")}
											icon="eye"
											size="small"
										/>
									</ContactRow>
								</li>
							))}
						</ContactList>
					</>
				) : (
					<Loading />
				)}
			</DrawerBody>
		</Drawer>
	);
};
